import { Component, OnInit, TemplateRef, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import { NgSelectConfig } from "@ng-select/ng-select";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { BsModalService } from "ngx-bootstrap/modal";

interface Group {
  name: string;
  selectedValue?: string;
}

@Component({
  selector: "app-detailinquiry-editproduct",
  templateUrl: "./detailinquiry-editproduct.component.html",
  styleUrls: ["./detailinquiry-editproduct.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailinquiryEditproductComponent implements OnInit {
  @ViewChild("multiDuplicate1") multiDuplicate1: any;
  http: any;
  minQuoteDate: Date;
  maxExpDate: Date;
  maxQuoteDate: Date;

  comps: string[] = [];
  productGroupHd: Observable<string[]>;
  userRId: any;
  @ViewChild("showvat") showvat: any;
  @ViewChild("showmti") showmti: any;
  Totalrec: any;
  invalid: any;
  valid: number;
  dataarray: any;
  isCollapsed1: boolean = false;
  itemShow: any;
  CategoryShow: any;
  brandShow: any;
  checkDelete: any;
  modalRef: any;
  MTIshow: any;
  inqProductId: any;
  rowId: any;
  errorMsg: any;
  Product: any;

  disableDate() {
    return false;
  }
  vertical: any = [];
  groups: any = [];
  items: any = [];
  rowvalue: any = [];
  descript: any = [];
  vat: any = [];
  productId: any = [];
  brand: any = [];
  unit: any = [];
  specified: any = [];
  options: any = [];
  registerForm: FormGroup;
  formdata: any = [];
  productData: any = [];
  submitted = false;
  submitted1 = false;
  multiClick = false;
  id: any;
  businessStream: any = [];
  showmodel: any = [];
  detailStream: any = [];
  QuoteMargin: any;
  dollar: boolean = false;
  businessCategory: any = [];
  productBrand: any = [];
  isRender: boolean = false;
  BusinessVerticalId: any;
  formGroup: any;
  dropdownSetting: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  showCurrencyArray: any = [];
  showUnitArray: any = [];
  showDeliveryArray: any = [];
  showIncoArray: any = [];
  showApplicationArray: any = [];
  BrandListArray: any = [];
  selectedItem: any[];
  CurrencySetting: any = {};
  userId: any;
  GrossValue: number = 0;
  DiscountPer: number = 0;
  TotalDiscountValue: number = 0;
  TotalPrice: number = 0;
  TotalPriceQAR: number = 0;
  QuotedValue: number = 0;
  DiscountValue: number = 0;
  TotalQuotedSalesValue: number = 0;
  TotalReportedQuotedSalesValue: number = 0;
  TotalGrossQAR: number = 0;
  TotalDiscountQAR: number = 0;
  TotalTaxAmount: number = 0;
  TotalTaxAmountQAR: number = 0;
  TotalPricewithVat: number = 0;
  TotalPricewithVatQAR: number = 0;
  QuotedDate: any = "";
  ExpOrderDate: any = "";
  inquiryProduct: any = [];
  InquiryId: string;
  currentPage: any = 0;
  pageSize: any = 99;
  selectedCategory: any = [];
  selectedModel: any = [];
  selectedBrand: any = [];
  rowIndex: any = [];
  showSpecifiedArray: any = [];
  dropdownSetting7: any = {};
  currency: string = "";
  currency_name: string = "";
  totalProductSize: number;
  loader: boolean = false;
  errror: any = "";
  selectedCurrency = [];
  selectedCurrencyName: any;
  selectedCurrencyId: number = 0;
  selectedcSN: any;
  previousPrice: number = 0;
  previousPersent: number = 0;
  previousvat: number = 0;
  permission: any;
  nonEdit: boolean = true;
  isValid: boolean;
  businessVertical: any = [];
  businessVerticalArray: any = [];
  freightAmountQARValue: number = 0;
  freightCharges: number = 0;

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private config: NgSelectConfig,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef
  ) {
    this.config.notFoundText = "Custom not found";
    this.config.appendTo = "body";
    this.config.bindValue = "value";
  }

  ngOnInit(): void {
    let UserId = localStorage.getItem("userId");
    this.userId = this.UserService.decryptData(UserId);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);

    let decid = this.route.snapshot.params["id"];
    decid = decid.toString().replace("Ar1t", "=").replace("FGH", "/").replace("THD", "+");
    this.id = this.UserService.decryptData(decid);
    this.registerForm = this.formBuilder.group({
      Currency: ["", Validators.required],
      ReportedCurrencyRate: ["", [Validators.required, Validators.max(100000)]],
      ObjInqProduct: this.formBuilder.array([]),
      InquiryId: this.id,
      QuotedValue: ["base currency"],
      TotalGrossQAR: [""],
      DiscountValue: [""],
      TotalDiscountQAR: [""],
      TotalTaxAmount: [""],
      TotalTaxAmountQAR: [""],
      TotalPricewithVat: [""],
      TotalPricewithVatQAR: [""],
      TotalQuotedSalesValue: [""],
      TotalReportedQuotedSalesValue: [""],
      QuotedDate: ["", Validators.required],
      Application: [""],
      DeliveryPeriod: [""],
      IncoTerms: [""],
      ExpOrderDate: ["", Validators.required],
      QuoteMargin: ["", [Validators.max(100), Validators.min(0), Validators.required]],
      FreightAmountQAR: [0],
      FreightRemark: [""]
    });

    this.dropdownSetting = {
      singleSelection: true,
      text: "Brand",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Delivery Period",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Application",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: true,
      text: "Category",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting5 = {
      singleSelection: true,
      text: "Item Code",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting6 = {
      singleSelection: true,
      text: "Inco Terms",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.CurrencySetting = {
      singleSelection: true,
      text: "Currency Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      searchBy: ["itemName"],
      classes: "custom-class",
      badgeShowLimit: 1,
    };

    let data = {
      InquiryId: this.id,
      ItemPerPages: this.pageSize,
      PageNo: this.currentPage + 1,
    };
    this.isRender = false;
    this.UserService.GetInquiryProductByInquiryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.inquiryProduct = res["ContactList"];
        this.totalProductSize = res["TotalRecord"];
        if (this.totalProductSize == 0) {
          this.dollar = false;
        } else {
          this.dollar = true;
          let ObjInqProduct = this.registerForm.get("ObjInqProduct") as FormArray;
          for (let i in this.inquiryProduct) {
            this.specified[i] = res["ContactList"][i]["Specified"];
            if (res["ContactList"][i]["BusinessVertical"] != 1) {
              this.specified[i] = false;
            }

            this.vertical[i] = res["ContactList"][i]["BusinessVertical"];
            this.groups[i] = res["ContactList"][i]["CategoryId"];
            this.descript[i] = res["ContactList"][i]["Description"];

            this.showmodel[i] = [];

            this.items[i] = res["ContactList"][i]["ProductId"];

            // this.vat[i] = res["ContactList"][i]["VatRate"];
            this.vat[i] = (res["ContactList"][i]["VatRate"]).toFixed(2);

            this.options[i] = res["ContactList"][i]["Origin"];

            this.rowvalue[i] = 1;

            this.productId[i] = res["ContactList"][i]["ProductId"];

            if (res["ContactList"][i]["Brand"] == null || res["ContactList"][i]["Brand"] == 0 || res["ContactList"][i]["Brand"] == ""
            ) {
              this.brand[i] = 0;
            } else {
              this.brand[i] = res["ContactList"][i]["Brand"];
            }

            this.unit[i] = res["ContactList"][i]["UnitType"];

            this.itemShow = res["ContactList"][i]["Code"];
            this.CategoryShow = res["ContactList"][i]["BusinessCategoryName"];
            this.brandShow = res["ContactList"][i]["ProductBrandName"];

            ObjInqProduct.push(
              this.formBuilder.group({
                checkItem: [""],
                InquiryProductId: [this.inquiryProduct[i].InquiryProductId],
                ProductId: [this.inquiryProduct[i]["ProductId"]],
                BusinessVertical: [this.vertical[i], Validators.required],
                BusinessCategory: [this.inquiryProduct[i]["CategoryId"], Validators.required],
                ProductBrandName: this.inquiryProduct[i]["Brand"],
                Origin: this.options[i],
                Specified: this.specified[i],
                Itemcode: [this.inquiryProduct[i]["ProductId"], Validators.required],
                Code: [this.inquiryProduct[i]["Code"]],
                Description: [this.descript[i], Validators.required],
                Qty: [this.inquiryProduct[i].Qty, Validators.required],
                Price: [this.inquiryProduct[i].Price, Validators.required],
                GrossValue: [this.inquiryProduct[i].GrossValue],
                // DiscountPer: [this.inquiryProduct[i].DiscountPer],
                DiscountPer: (Number(this.inquiryProduct[i]?.DiscountPer) || 0).toFixed(2),
                TotalDiscountValue: [this.inquiryProduct[i].DiscountValue],
                UnitType: [this.unit[i], Validators.required],
                TotalPrice: [this.inquiryProduct[i].TotalPrice],
                TotalPriceQAR: [this.inquiryProduct[i].TotalPriceQAR],
                VatRate: this.vat[i],
                VatValue: [this.inquiryProduct[i].VatValue],
                TotalPriceWithVat: [this.inquiryProduct[i].TotalPriceWithVat],
                TotalPriceQARWithVat: [this.inquiryProduct[i].TotalPriceQARWithVat],
                Competitor: [this.inquiryProduct[i].Competitor],
                Remark: [this.inquiryProduct[i].Remark],
                Status: ["1"],
                check: false,
              })
            );
            // this.getPrice(i);
            // this.getTotalPrice(i);
          }
        }
        this.GetInquiryDetail();
        this.isRender = false;
      }
    });

    this.GetCurrency();
    this.GetDelivery();
    this.GetInco();
    this.GetApplication();
    this.GetUnit();
    this.GetSpecified();
    this.GetInquiryProductCompetitor();
  }

  NewSearchFun(ev, i) {
    let value1 = ev.target.value;
    this.productGroupHd = this.registerForm.controls["ObjInqProduct"][
      "controls"
    ][i]["controls"]["Competitor"].valueChanges.pipe(
      startWith(""),
      map((value: string) => this._filter(value1 || ""))
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.comps.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  GetInquiryDetail() {
    let data1 = {
      InquiryId: this.id,
    };
    this.spinner.show();
    this.UserService.GetInquiryDetailById(data1).subscribe((res) => {
      if (res["result"] == "success") {
        this.formdata = res["Data"];
        this.BusinessVerticalId = res["Data"]["BusinessVerticalId"];
        this.freightCharges = res["Data"]["FreightAmount"];
        this.freightAmountQARValue = res["Data"]["FreightAmountQAR"];
        this.registerForm.get('FreightAmountQAR').setValue(this.freightAmountQARValue.toFixed(2));
        this.registerForm.get('FreightRemark').setValue(res["Data"]["FreightRemark"]);
        if (res["Data"]["CountryId"]) {
          this.dollar = true;
          this.selectedCurrency = [
            {
              id: res["Data"]["CountryId"],
              itemName: res["Data"]["currencyName"],
            },
          ];
          this.selectedCurrency.forEach((element) => {
            this.selectedCurrencyName = element["itemName"];
            this.selectedCurrencyId = element["id"];
            this.selectedcSN = element["cSN"];
          });
        }
        this.currency = res["Data"]["currencyName"];
        this.currency_name = this.currency;
        if (res["Data"]["DeliveryPeriod"]) {
          this.selectedDelivery = [
            {
              id: res["Data"]["DeliveryPeriod"],
              itemName: res["Data"]["DeliveryPeriodName"],
            },
          ];
        }
        if (res["Data"]["IncoTerms"]) {
          this.selectedInco = [
            {
              id: res["Data"]["IncoTerms"],
              itemName: res["Data"]["IncoTermsName"],
            },
          ];
        }
        if (res["Data"]["Application"]) {
          this.selectedApplication = [
            {
              id: res["Data"]["Application"],
              itemName: res["Data"]["ApplicationName"],
            },
          ];
        }

        this.minQuoteDate = new Date(
          moment(res["Data"]["ReceivedDate"], "DD-MM-YYYY").format("MM-DD-YYYY")
        );

        this.registerForm.patchValue({
          ReportedCurrencyRate: res["Data"]["ReportedCurrencyRate"],
          QuotedDate: res["Data"]["QuotedDate"],
          QuotedValue: res["Data"]["QuotedValue"],
          TotalGrossQAR: res["Data"]["TotalGrossQAR"],
          ExpOrderDate: res["Data"]["ExpOrderDate"],
          QuoteMargin: res["Data"]["QuoteMargin"],
          TotalReportedQuotedSalesValue: res["Data"]["ReportedValue"],
          BaseCurrencyRate: res["Data"]["BaseCurrencyRate"],
          DiscountValue: res["Data"]["TotalDiscountValue"],
          TotalDiscountQAR: res["Data"]["TotalDiscountQAR"],
          TotalQuotedSalesValue: res["Data"]["TotalQuotedSalesValue"],
          TotalTaxAmount: res["Data"]["TotalTaxAmount"],
          TotalTaxAmountQAR: res["Data"]["TotalTaxAmountQAR"],
          TotalPricewithVat: res["Data"]["TotalPricewithVat"],
          TotalPricewithVatQAR: res["Data"]["TotalPricewithVatQAR"],
        });
        if (res["Data"]["QuoteMargin"] == 0) {
          this.registerForm.get("QuoteMargin").setValue("");
        }

        let items = this.registerForm.get("ObjInqProduct") as FormArray;
        for (let i = 0; i < items.length; i++) {
          this.getPrice(i);
          this.getTotalPrice(i);
        }
      }
      this.spinner.hide();
      // this.GetDetailsByBusiness(this.BusinessVerticalId);
      this.getBusinessVertical();
    });
  }

  getBusinessVertical() {
    let data = {};
    this.UserService.GetBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessVerticalArray = res;
        this.businessVertical = [];
        for (const verticalData of this.businessVerticalArray["Data"]) {
          this.businessVertical.push({
            id: verticalData["Id"],
            itemName: verticalData["Name"],
          });
        }
      } else {
        this.businessVerticalArray = [];
      }
    });
    this.GetDataByBusinessVertical()
  }
  
  GetDetailsByBusiness(verticalId: number, index: any) {
    let data = { BusinessVerticalId: verticalId };
    this.UserService.GetDetailsByBusinessVertical(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.businessCategory[index] = []
        res["BusinessCategory"].forEach((element) => {
          this.businessCategory[index].push({
            id: element.BusinessCategoryId,
            itemName: element.Name,
          });
        });
        let detailStreamArray = res;
        this.detailStream = [];
        for (const businessCategoryData of detailStreamArray[
          "BusinessCategory"
        ]) {
          this.detailStream.push({
            id: businessCategoryData["BusinessCategoryId"],
            itemName: businessCategoryData["Name"],
          });
        }
      } else {
        this.detailStream = [];
      }
    });
  }

  GetDataByBusinessVertical() {
    let data1 = {
      BusinessVertical: 0,
    };
    this.spinner.show();
    this.UserService.GetProductListByBVId(data1).subscribe((res) => {
      if (res["result"] == "success") {
        this.productData = res["Data"];
        this.spinner.hide();

        for (let j in this.inquiryProduct) {
          this.productBrand[j] = [];
          this.productBrand[j].push({
            id: 0,
            itemName: "None",
          });

          this.selectedDetailId = this.inquiryProduct[j]["CategoryId"];
          this.businessCategory[j] = []
          for (const product of this.productData) {
            if (this.selectedDetailId == product.CategoryId) {
              this.businessCategory[j].push({
                id: product.CategoryId,
                itemName: product.CategoryName,
              });
            }
            if (this.selectedDetailId == product.CategoryId) {
              this.showmodel[j].push({
                id: product.ProductId,
                itemName: product.Code,
              });

              if (product.ProductBrandName != null) {
                this.productBrand[j].push({
                  id: product.Brand,
                  itemName: product.ProductBrandName,
                });
              }
            }
          }
          this.productBrand[j] = this.productBrand[j].filter(
            (thing, i, arr) => arr.findIndex((t) => t.id == thing.id) == i
          );
        }
      }
      this.isRender = true;
    });
  }

  countryList: any = [];
  showCurrency: any = [];
  GetCurrency() {
    let data = {
      UserId: this.userId,
    };
    this.UserService.GetCurrencyList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCurrencyArray = res;
        this.showCurrency = [];
        this.countryList = [];
        for (const currencyData of this.showCurrencyArray["Data"]) {
          this.showCurrency.push({
            id: currencyData["id"],
            itemName: `${currencyData["currency"]} (${currencyData["currency_name"]})`,
            cSN: currencyData["currency"],
          });
          this.countryList.push({
            id: currencyData["id"],
            itemName: currencyData["name"],
          });
        }
      } else {
        this.showCurrencyArray = [];
        this.countryList = [];
      }
    });
  }

  onCurrencySelect(item: any) {
    this.selectedCurrencyName = "";
    this.selectedCurrencyId = 0;
    this.selectedCurrency.forEach((element) => {
      this.selectedCurrencyName = element["itemName"];
      this.selectedCurrencyId = element["id"];
      this.selectedcSN = element["cSN"];
    });
    this.currency_name = this.selectedcSN;
    if (this.currency_name == "QAR") {
      this.registerForm.get("ReportedCurrencyRate").setValue(1);
    }
  }

  showCompetitor: any = [];
  GetInquiryProductCompetitor() {
    this.comps = [];
    let data = {
      SearchWord: "",
      ItemPerPages: 500,
      PageNo: 1,
    };
    this.UserService.GetInquiryProductCompetitor(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showCompetitor = res;
        this.comps = [];
        for (const contact of this.showCompetitor["ContactList"]) {
          this.comps.push(contact);
        }
      } else {
        this.comps = [];
      }
    });
  }

  showUnit: any = [];
  GetUnit() {
    let data = {};
    this.UserService.GetUnitType(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showUnit = res["Data"];
      }
    });
  }

  showSpecified: any = [];
  GetSpecified() {
    let data = {};
    this.UserService.GetSpecifiedList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showSpecified = res["Data"];
      }
    });
  }

  showDelivery: any = [];
  GetDelivery() {
    let data = {};
    this.UserService.GetDeliveryPeriodList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showDeliveryArray = res;
        this.showDelivery = [];
        for (const deliveryData of this.showDeliveryArray["Data"]) {
          this.showDelivery.push({
            id: deliveryData["DeliveryPeriodId"],
            itemName: deliveryData["Name"],
          });
        }
      } else {
        this.showDeliveryArray = [];
      }
    });
  }
  selectedDelivery: any = [];
  selectedDeliveryName: any;
  selectedDeliveryId: any;
  onDeliverySelect(item: any) {
    this.selectedDeliveryName = "";
    this.selectedDeliveryId = "";
    this.selectedDelivery.forEach((element) => {
      this.selectedDeliveryName += element["itemName"];
      this.selectedDeliveryId += element["id"];
    });
  }

  showInco: any = [];
  GetInco() {
    let data = {};
    this.UserService.GetIncoTermList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showIncoArray = res;
        this.showInco = [];
        for (const incoData of this.showIncoArray["Data"]) {
          this.showInco.push({
            id: incoData["IncoTermId"],
            itemName: incoData["Name"],
          });
        }
      } else {
        this.showIncoArray = [];
      }
    });
  }
  selectedInco: any = [];
  selectedIncoName: any;
  selectedIncoId: any;
  onIncoSelect(item: any) {
    this.selectedIncoName = "";
    this.selectedIncoId = "";
    this.selectedInco.forEach((element) => {
      this.selectedIncoName += element["itemName"];
      this.selectedIncoId += element["id"];
    });
  }

  showApplication: any = [];
  GetApplication() {
    let data = {};
    this.UserService.GetApplicationList(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showApplicationArray = res;
        this.showApplication = [];
        for (const applicationData of this.showApplicationArray["Data"]) {
          this.showApplication.push({
            id: applicationData["ApplicationId"],
            itemName: applicationData["Name"],
          });
        }
      } else {
        this.showApplicationArray = [];
      }
    });
  }
  selectedApplication: any = [];
  selectedApplicationName: any;
  selectedApplicationId: any;
  onApplicationSelect(item: any) {
    this.selectedApplicationName = "";
    this.selectedApplicationId = "";
    this.selectedApplication.forEach((element) => {
      this.selectedApplicationName += element["itemName"];
      this.selectedApplicationId += element["id"];
    });
  }

  BrandList: any = [];
  getBrandItemList(itemName: any, j: number) {
    let data = {
      Searchword: itemName,
      Type: "Brand",
      BusinessVertical: this.BusinessVerticalId,
    };
    this.UserService.GetBrandAndItemCodeDetails(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.BrandListArray = res;
        this.showmodel[j] = [];
        for (const brandData of this.BrandListArray["Data"]) {
          this.showmodel[j].push({
            id: brandData["Id"],
            itemName: brandData["Name"],
          });
        }
      }
    });
  }
  selectedBrandItem: any = [];
  selectedBrandItemName: any;
  selectedBrandItemId: any;
  onBrandItemSelect(item: any) {
    this.selectedBrandItemName = "";
    this.selectedBrandItemId = "";
    this.selectedBrandItem.forEach((element) => {
      this.selectedBrandItemName += element["itemName"];
      this.selectedBrandItemId += element["id"];
    });
    this.ItemList = [];
    this.selectedItem = [];
  }

  ItemArray: any = [];
  ItemList: any = [];
  getItemByBrandId(itemName: any, j: number) {
    let data = {
      Searchword: itemName,
      Type: "Code ",
      BusinessVertical: this.BusinessVerticalId,
    };
    this.UserService.GetBrandAndItemCodeDetails(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.ItemArray = res;
        this.productBrand[j] = [{ id: 0, itemName: "None" }];
        for (const itemData of this.ItemArray["Data"]) {
          this.productBrand[j].push({
            id: itemData["Id"],
            itemName: itemData["Name"],
          });
        }
      }
    });
  }
  selectedItemName: string = "";
  selectedItemId: string = "";
  onItemsSelect(item: any) {
    this.selectedItemName = "";
    this.selectedItemId = "";
    this.selectedItem.forEach((element) => {
      this.selectedItemName = element["itemName"];
      this.selectedItemId = element["id"];
    });
  }

  selectedVerticalId: number = 0;
  onBusinessVerticalSelect($event, j) {
    this.businessCategory[j] = [];
    this.groups[j] = [];
    this.categoryDeSelect(j);
    if ($event) {
      this.selectedVerticalId = $event.id;
    }
    if (this.selectedVerticalId != undefined && this.selectedVerticalId != null && this.selectedVerticalId != 0) {
      this.GetDetailsByBusiness(this.selectedVerticalId, j);
    }
    else {
      this.businessCategory[j] = [];
      this.groups[j] = [];
      this.categoryDeSelect(j);
    }
  }

  selecteddetail: string = "";
  selectedDetailId: number = 0;
  onDetailSelect($event, j) {
    this.selecteddetail = "";
    if ($event) {
      this.selectedDetailId = $event.id;
    }
    this.showmodel[j] = [];
    this.descript[j] = "";
    this.brand[j] = [];
    this.productBrand[j] = [];
    this.items[j] = [];
    this.brand[j] = 0;
    this.productBrand[j].push({
      id: 0,
      itemName: "None",
    });
    if ($event) {
      for (const productDataItem of this.productData) {
        if (this.selectedDetailId == productDataItem.CategoryId) {
          this.showmodel[j].push({
            id: productDataItem.ProductId,
            itemName: productDataItem.Code,
          });
          if (productDataItem.ProductBrandName != null) {
            this.productBrand[j].push({
              id: productDataItem.Brand,
              itemName: productDataItem.ProductBrandName,
            });
          }
        }
      }

      this.productBrand[j] = this.productBrand[j].filter(
        (thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i
      );
    } else {
      this.categoryDeSelect(j);
    }
  }

  categoryDeSelect(j) {
    this.selectedDetailId = 0;
    this.showmodel[j] = [];
    this.productBrand[j] = [];
    this.descript[j] = "";
    this.items[j] = [];
    this.brand[j] = [];
  }

  onBrandItemDeSelect(j) {
    this.showmodel[j] = [];
    this.descript[j] = "";
    this.brand[j] = 0;
    this.productBrand[j] = [];
    this.items[j] = [];
    this.productBrand[j].push({
      id: 0,
      itemName: "None",
    });
    for (const productDataItem of this.productData) {
      if (this.selectedDetailId == productDataItem.CategoryId) {
        this.showmodel[j].push({
          id: productDataItem.ProductId,
          itemName: productDataItem.Code,
        });
        if (productDataItem.ProductBrandName != null) {
          this.productBrand[j].push({
            id: productDataItem.Brand,
            itemName: productDataItem.ProductBrandName,
          });
        }
      }
    }

    this.productBrand[j] = this.productBrand[j].filter(
      (thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i
    );
  }

  selectedmodel: string = "";
  selectedModelId: string = "";
  onModelSelect($event, itemName: any, j) {
    if ($event) {
      this.selectedmodel = "";
      this.selectedModelId = $event.id;
      for (const productDataItem of this.productData) {
        if (this.selectedModelId == productDataItem.ProductId) {
          this.descript[j] = productDataItem.Description;
          this.vat[j] = productDataItem.VatRate;
          this.productId[j] = productDataItem.ProductId;
          this.getItemByBrandId($event.itemName, j);
        }
      }
    } else {
      this.onBrandItemDeSelect(j);
    }
  }

  selectedbrand: string = "";
  selectedBrandlId: string = "";
  onBrandSelect($event, productBrand, j) {
    if ($event) {
      this.selectedbrand = "";
      this.selectedBrandlId = "";
      this.getBrandItemList($event.itemName, j);
    } else {
      this.onBrandItemDeSelect(j);
    }
  }

  getPrice(index: any) {
    let ReportedCurrency = this.registerForm.get("ReportedCurrencyRate").value;
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;
    let price = rows.value[index]?.Price;
    if (price > 999999.99) {
      price = this.previousPrice;
    }
    let quantity = rows.value[index]?.Qty;
    let Percent = rows.value[index]?.DiscountPer;
    if (Percent > 100) {
      Percent = this.previousPersent;
    }
    let grossValue = quantity * price;
    let Discount = (grossValue * Percent) / 100;
    let checkDis = Math.floor(Discount * 100) / 100;
    let TP = grossValue - checkDis;
    let TPQAR = TP * ReportedCurrency;
    let TotalPriceQAR = Math.floor(TPQAR * 100) / 100;

    rows.controls[index]?.patchValue({
      DiscountPer: Percent,
      GrossValue: grossValue,
      Price: price,
      TotalDiscountValue: checkDis,
      TotalPrice: TP,
      TotalPriceQAR: TotalPriceQAR,
    });

    this.totalsum();
    this.previousPrice = price;
    this.previousPersent = Percent;
  }

  getPrice1(index: any) {
    let ReportedCurrency = this.registerForm.get("ReportedCurrencyRate").value;
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;
    let price = rows.value[index]?.Price;
    let quantity = rows.value[index]?.Qty;
    let grossValue = quantity * price;

    // // Ensure TotalDiscountValue is less than grossValue
    let TotalDiscountValue = rows.value[index]?.TotalDiscountValue;

    if (TotalDiscountValue > grossValue) {
      TotalDiscountValue = grossValue;
      this.toastrService.error("Value can not be greater than Gross Value");
      rows.controls[index]?.patchValue({
        TotalDiscountValue: Number(TotalDiscountValue).toFixed(2),
      });
    }

    // Calculate DiscountPer based on TotalDiscountValue
    let Percent = (TotalDiscountValue / grossValue) * 100;

    rows.controls[index]?.patchValue({
      DiscountPer: Number(Percent).toFixed(2),
      TotalPrice: grossValue - (grossValue * Percent) / 100,
      TotalPriceQAR: (
        (grossValue - (grossValue * Percent) / 100) *
        ReportedCurrency
      ).toFixed(2),
      Percent: (TotalDiscountValue * 100) / grossValue,
    });

    this.totalsum();
    this.previousPrice = price;
    this.previousPersent = Percent;
  }

  getTotalPrice(index: any) {
    let ReportedCurrency = this.registerForm.get("ReportedCurrencyRate").value;
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;
    let vat = rows.value[index]?.VatRate;
    if (vat > 100) {
      vat = this.previousvat;
    }
    let TotalPrice = rows.value[index]?.TotalPrice;
    let taxAmount = (TotalPrice * vat) / 100;
    let tax_Amount = Math.floor(taxAmount * 100) / 100;
    let TotalPriceWithVat = TotalPrice + tax_Amount;
    let TotalPriceQARWithVat = TotalPriceWithVat * ReportedCurrency;
    let TTQARVAT = Math.floor(TotalPriceQARWithVat * 100) / 100;

    rows.controls[index]?.patchValue({
      VatRate: vat,
      VatValue: tax_Amount,
      TotalPriceWithVat: TotalPriceWithVat,
      TotalPriceQARWithVat: TTQARVAT,
    });
    this.totalsum();
    this.previousvat = vat;
  }

  getValue(event: any) {
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;
    for (const control of rows.controls) {
      control.patchValue({
        TotalPriceQAR: Number(
          control.value.TotalPrice * event.target.value
        ).toFixed(2),
        TotalPriceQARWithVat: Number(
          control.value.TotalPriceWithVat * event.target.value
        ).toFixed(2),
        TotalGrossQAR: Number(
          control.value.QuotedValue * event.target.value
        ).toFixed(2),
        TotalDiscountQAR: Number(
          control.value.DiscountValue * event.target.value
        ).toFixed(2),
        TotalTaxAmountQAR: Number(
          control.value.TotalTaxAmount * event.target.value
        ).toFixed(2),
      });
    }
  }

  totalsum() {
    this.freightAmountQARValue = this.registerForm.controls.FreightAmountQAR.value;
    this.freightCharges = Math.floor((this.freightAmountQARValue / this.registerForm.value.ReportedCurrencyRate) * 100) / 100;
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;
    this.QuotedValue = 0;
    this.DiscountValue = 0;
    this.TotalTaxAmount = 0;
    this.TotalQuotedSalesValue = 0;
    this.TotalPricewithVat = 0;
    this.TotalPricewithVatQAR = 0;
    this.TotalGrossQAR = 0;
    this.TotalDiscountQAR = 0;
    this.TotalTaxAmountQAR = 0;
    this.TotalReportedQuotedSalesValue = 0;
    for (const control of rows.controls) {
      if (control.value.Status == 1) {
        this.QuotedValue += Number(control.value.GrossValue);
        this.DiscountValue += Number(control.value.TotalDiscountValue);
        this.TotalQuotedSalesValue += Number(control.value.TotalPrice);
        this.TotalTaxAmount += Number(control.value.VatValue);
        this.TotalPricewithVat += Number(control.value.TotalPriceWithVat);
        this.TotalPricewithVatQAR += Number(control.value.TotalPriceQARWithVat);
        this.TotalReportedQuotedSalesValue += Number(control.value.TotalPriceQAR);
      }
    }
    this.TotalPricewithVatQAR = Number(this.TotalPricewithVatQAR) + Number(this.freightAmountQARValue);

    let TotalGrossQAR = this.QuotedValue * this.registerForm.value.ReportedCurrencyRate;
    let TotalGroQar = Math.floor(TotalGrossQAR * 100) / 100;
    let TotalDiscountQAR = this.DiscountValue * this.registerForm.value.ReportedCurrencyRate;
    let TotalDisQAR = Math.floor(TotalDiscountQAR * 100) / 100;
    let TotalTaxAmountQAR = this.TotalTaxAmount * this.registerForm.value.ReportedCurrencyRate;
    let TotalVatQAR = Math.floor(TotalTaxAmountQAR * 100) / 100;

    this.TotalGrossQAR = TotalGroQar;
    this.TotalDiscountQAR = TotalDisQAR;
    this.TotalTaxAmountQAR = TotalVatQAR;

    let TotalReportedWoVat = Math.floor(this.TotalReportedQuotedSalesValue * 100) / 100;
    let TotalWithVatQar = Math.floor(this.TotalPricewithVatQAR * 100) / 100;

    this.registerForm.patchValue({
      QuotedValue: this.QuotedValue.toFixed(2),
      TotalGrossQAR: this.TotalGrossQAR.toFixed(2),
      DiscountValue: this.DiscountValue.toFixed(2),
      TotalDiscountQAR: this.TotalDiscountQAR.toFixed(2),
      TotalQuotedSalesValue: this.TotalQuotedSalesValue.toFixed(2),
      TotalReportedQuotedSalesValue: TotalReportedWoVat,
      TotalTaxAmount: Number(this.TotalTaxAmount).toFixed(2),
      TotalTaxAmountQAR: Number(this.TotalTaxAmountQAR).toFixed(2),
      TotalPriceWithVat: this.TotalPricewithVat.toFixed(2),
      TotalPricewithVatQAR: TotalWithVatQar,
    });
  }

  currencySave() {
    if (
      this.registerForm.value.ReportedCurrencyRate != null &&
      this.registerForm.value.Currency[0] != null
    ) {
      if (this.registerForm.value.ReportedCurrencyRate <= 0) {
        this.toastrService.error("Value must be greater than 0");
      } else if (this.registerForm.value.ReportedCurrencyRate > 100000) {
        this.toastrService.error(
          "Value must be less than or equal to 99999.99"
        );
      } else if (
        this.registerForm.value.Currency[0]["itemName"] == "QAR (Qatar)" &&
        this.registerForm.value.ReportedCurrencyRate != 1
      ) {
        this.toastrService.error("Value should be 1,if currency is QAR");
      } else {
        this.dollar = true;
        this.currency = this.registerForm.value.Currency[0]["itemName"];
        this.submitted1 = true;
        let data = {
          InquiryId: this.id,
          CountryId: this.registerForm.value.Currency[0]["id"],
          BaseCurrencyRate: 1,
          ReportedCurrencyRate: this.registerForm.value.ReportedCurrencyRate,
        };
        this.spinner.show();
        this.UserService.UpdateInquiryCurrencyRate(data).subscribe((res) => {
          if (res["result"] == "success") {
            if (!this.dollar) {
              this.Addrow();
            }
            this.spinner.hide();
            this.toastrService.success(res["Msg"]);
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            this.toastrService.error(res["Msg"]);
          } else {
            this.spinner.hide();
            this.toastrService.error(res["Message"]);
          }
          this.submitted1 = false;
        });
      }
    } else {
      this.toastrService.error("Please Fill Currency Fields");
      this.submitted1 = true;
    }
  }

  currencyEdit() {
    this.dollar = false;
  }

  newFunc(event: any) {
    this.maxExpDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }

  newFunc2(event: any) {
    this.maxQuoteDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }

  pasteNumbrother(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ Price: newText });
  }

  pasteNum(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ TotalDiscountValue: newText });
  }

  singleWhiteSpaceAllowed(event) {
    let RegEx = new RegExp(/^([0-9])*$/g);
    let str = event.target.value
    if (RegEx.test(str)) {
      return event.target.value
    } else {
      let nameString = str.replace(/\s+/g, '');
      nameString = str.replace(/[^0-9]+/g, '');
      event.target.value = nameString.replace(/^\s+/g, "");
      this.registerForm.patchValue({ 'Qty': nameString.replace(/^\s+/g, "") });
    }
  }

  onSubmit() {
    if (!this.checkProductList()) {
      this.toastrService.error(
        "Minimum 1 item row should be added to save the product"
      );
      return;
    } else if (!this.dollar) {
      this.toastrService.error("Please save currency first");
      return;
    }
    this.submitted = true;
    this.registerForm.value.Currency = this.selectedCurrencyId;
    this.registerForm.patchValue({
      DiscountValue: this.DiscountValue,
      TotalDiscountQAR: this.TotalDiscountQAR,
      QuotedValue: this.QuotedValue,
      TotalQuotedSalesValue: this.TotalQuotedSalesValue,
      TotalReportedQuotedSalesValue: this.TotalReportedQuotedSalesValue,
      TotalGrossQAR: this.TotalGrossQAR.toFixed(2),
      TotalTaxAmount: this.TotalTaxAmount.toFixed(2),
      TotalTaxAmountQAR: this.TotalTaxAmountQAR.toFixed(2),
      TotalPricewithVat: this.TotalPricewithVat,
      TotalPricewithVatQAR: this.TotalPricewithVatQAR.toFixed(2),
    });
    let data = this.registerForm.value;
    let rows = this.registerForm.get("ObjInqProduct") as FormArray;

    for (let key in rows.controls) {
      if (
        data.ObjInqProduct[key].ProductBrandName == undefined ||
        data.ObjInqProduct[key].ProductBrandName == null ||
        data.ObjInqProduct[key].ProductBrandName == Array.isArray(Array)
      ) {
        data.ObjInqProduct[key].ProductBrandName = 0;
      }
    }

    data = this.registerForm.value;
    if (
      this.registerForm.value.QuotedDate &&
      this.registerForm.value.QuotedDate != ""
    ) {
      this.QuotedDate = moment(
        this.registerForm.value.QuotedDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.ExpOrderDate &&
      this.registerForm.value.ExpOrderDate != ""
    ) {
      this.ExpOrderDate = moment(
        this.registerForm.value.ExpOrderDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    data.QuotedDate = this.QuotedDate;
    data.ExpOrderDate = this.ExpOrderDate;
    if (this.registerForm.valid) {
      this.multiClick = true;
      if (this.registerForm.value.QuoteMargin) {
        this.QuoteMargin = this.registerForm.value.QuoteMargin * 1;
      }
      if (data.Currency == undefined || data.Currency.length == 0) {
        data.Currency = 0;
      }
      if (data.DeliveryPeriod != undefined && data.DeliveryPeriod.length > 0) {
        data.DeliveryPeriod = data.DeliveryPeriod[0].id;
      } else {
        data.DeliveryPeriod = 0;
      }
      if (data.IncoTerms != undefined && data.IncoTerms.length > 0) {
        data.IncoTerms = data.IncoTerms[0].id;
      } else {
        data.IncoTerms = 0;
      }
      if (data.Application != undefined && data.Application.length > 0) {
        data.Application = data.Application[0].id;
      } else {
        data.Application = 0;
      }
      console.log(data, "data")
      this.spinner.show();
      this.UserService.AddupdateInquiryProduct(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.errror = "";
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.id);
            encryptid = encryptid
              .toString()
              .replace("=", "Ar1t")
              .replace("/", "FGH")
              .replace("+", "THD");
            if (this.permission.Inquiry_View == 1 || this.userRId == 1) {
              this.router.navigate(["/inquiry/detailinquiry", encryptid]);
            } else {
              this.router.navigate(["/inquiry/inquirylist"]);
            }
          } else if (res["result"] == "Failed") {
            this.spinner.hide();
            if (res["error"] == "Vat Rate") {
              this.showvat.nativeElement.click();
              this.isCollapsed1 = true;
              this.dataarray = res["Data"];
            }
            this.toastrService.error(res["Msg"]);
          } else {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          }
          this.spinner.hide();
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
            this.f.QuoteMargin.setValue("");
            this.multiClick = false;
          }
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required Fields");
      this.submitted = true;
    }
  }

  checkProductList() {
    let ObjInqProduct = this.registerForm.get("ObjInqProduct") as FormArray;
    for (const control of ObjInqProduct.controls) {
      if (control.value.Status == 1) {
        return true;
      }
    }
    return false;
  }

  PriceValidators = [Validators.required];
  Addrow() {
    this.nonEdit = false;
    if (!this.dollar) {
      this.toastrService.error("Please save currency first");
      return;
    }
    let ObjInqProduct = this.registerForm.get("ObjInqProduct") as FormArray;
    this.rowvalue[ObjInqProduct.length] = 1;
    if (ObjInqProduct.length <= 98) {
      this.showmodel[ObjInqProduct.length] = [];
      this.productBrand[ObjInqProduct.length] = [];

      let specified;

      if (this.BusinessVerticalId != 1) {
        specified = false;
      } else {
        specified = true;
        this.specified[ObjInqProduct.length] = true;
      }
      this.unit[ObjInqProduct.length] = 1;

      ObjInqProduct.push(
        this.formBuilder.group({
          checkItem: [""],
          InquiryProductId: 0,
          ProductId: [""],
          BusinessVertical: [0, Validators.required],
          BusinessCategory: ["", Validators.required],
          ProductBrandName: [0],
          Origin: [""],
          Specified: specified,
          Itemcode: ["", Validators.required],
          Description: ["", Validators.required],
          Qty: [1, [Validators.required, Validators.min(1)]],
          Price: ["", this.PriceValidators],
          GrossValue: [0],
          DiscountPer: [0],
          TotalDiscountValue: [0],
          UnitType: [1, Validators.required],
          TotalPrice: [0],
          TotalPriceQAR: [0],
          VatRate: [0],
          VatValue: [0],
          TotalPriceWithVat: [0],
          TotalPriceQARWithVat: [0],
          Competitor: [""],
          Remark: [""],
          Status: ["1"],
          blankRow: [""],
          check: true,
        })
      );
      this.descript[this.descript.length] = "";
      this.vat[this.vat.length] = 0;
    } else {
      this.toastrService.error("Maximum 99 rows are allowed at once");
    }
  }

  copyRow(i: any) {
    this.rowIndex.push(i);
  }

  Duplicate() {
    if (!this.dollar) {
      this.toastrService.error("Please save currency first");
      return;
    }
    let ObjInqProduct = this.registerForm.get("ObjInqProduct") as FormArray;
    if (ObjInqProduct.length + this.rowIndex.length <= 99) {
      for (let i = 0; i < this.rowIndex.length; i++) {
        this.vertical[ObjInqProduct.length] = this.vertical[this.rowIndex[i]];
        this.showmodel[ObjInqProduct.length] = this.showmodel[this.rowIndex[i]];
        this.productBrand[ObjInqProduct.length] = this.productBrand[this.rowIndex[i]];
        this.businessCategory[ObjInqProduct.length] = this.businessCategory[this.rowIndex[i]];
        // this.groups[ObjInqProduct.length] = this.groups[this.rowIndex[i]];
        this.groups[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].BusinessCategory;
        this.items[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].Itemcode;
        this.descript[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].Description;
        this.productId[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].ProductId;
        this.brand[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].ProductBrandName;
        this.unit[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].UnitType;
        this.specified[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].Specified;
        this.options[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].Origin;
        this.rowvalue[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].Status;
        this.vat[ObjInqProduct.length] = ObjInqProduct.value[this.rowIndex[i]].VatRate;
        ObjInqProduct.push(
          this.formBuilder.group({
            checkItem: [""],
            InquiryProductId: 0,
            ProductId: this.productId[this.rowIndex[i]],
            BusinessVertical: [this.vertical[this.rowIndex[i]], Validators.required],
            BusinessCategory: [this.groups[this.rowIndex[i]], Validators.required],
            ProductBrandName: this.productBrand[this.rowIndex[i]],
            Origin: [ObjInqProduct.value[this.rowIndex[i]].Origin],
            Specified: [ObjInqProduct.value[this.rowIndex[i]].Specified],
            Itemcode: [ObjInqProduct.value[this.rowIndex[i]].Itemcode, Validators.required],
            Description: [ObjInqProduct.value[this.rowIndex[i]].Description, Validators.required],
            Qty: [ObjInqProduct.value[this.rowIndex[i]].Qty, Validators.required],
            Price: [ObjInqProduct.value[this.rowIndex[i]].Price, Validators.required],
            GrossValue: [ObjInqProduct.value[this.rowIndex[i]].GrossValue],
            DiscountPer: [ObjInqProduct.value[this.rowIndex[i]].DiscountPer],
            TotalDiscountValue: [ObjInqProduct.value[this.rowIndex[i]].TotalDiscountValue],
            UnitType: [ObjInqProduct.value[this.rowIndex[i]].UnitType, Validators.required],
            TotalPrice: [ObjInqProduct.value[this.rowIndex[i]].TotalPrice],
            TotalPriceQAR: [ObjInqProduct.value[this.rowIndex[i]].TotalPriceQAR],
            VatRate: [ObjInqProduct.value[this.rowIndex[i]].VatRate],
            VatValue: [ObjInqProduct.value[this.rowIndex[i]].VatValue],
            TotalPriceWithVat: [ObjInqProduct.value[this.rowIndex[i]].TotalPriceWithVat],
            TotalPriceQARWithVat: [ObjInqProduct.value[this.rowIndex[i]].TotalPriceQARWithVat],
            Competitor: [ObjInqProduct.value[this.rowIndex[i]].Competitor],
            Remark: [ObjInqProduct.value[this.rowIndex[i]].Remark],
            Status: ["1"],
            blankRow: [""],
            check: true,
          })
        );
        this.getPrice(i);
        this.getTotalPrice(i);
      }
      this.rowIndex = [];
    } else {
      this.toastrService.error("Maximum 99 rows are allowed at once");
    }
  }

  count = 0;
  getCheckedItemList() {
    this.rowIndex = [];
    if (!this.dollar) {
      this.toastrService.error("Please save currency first");
      return;
    }
    this.count = 0;
    let ObjInqProduct = this.registerForm.get("ObjInqProduct") as FormArray;
    if (ObjInqProduct.length + this.rowIndex.length <= 99) {
      for (const product of ObjInqProduct.value) {
        if (product.checkItem) {
          this.count++;
        }
      }
      if (this.count == 0) {
        this.toastrService.error("Please select at least 1 row");
      } else if (this.count > 5) {
        this.toastrService.error("Only 5 row can be selected at once");
      } else {
        this.multiDuplicate1.nativeElement.click();
        for (const [i, product] of ObjInqProduct.value.entries()) {
          if (product.checkItem) {
            this.rowIndex.push(i);
          }
        }
      }
      setTimeout(() => {
        this.getPrice(0);
        this.getTotalPrice(0);
      }, 500);
    } else {
      this.toastrService.error("Maximum 99 rows are allowed at once");
    }
  }

  deleteOpenModal(template: TemplateRef<any>, index, id, product) {
    this.inqProductId = id;
    this.Product = product;
    this.rowId = index;
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-dialog-centered",
    });
  }

  decline() {
    this.isValid = false;
    this.modalRef.hide();
  }

  deleteConfirm(j: any, ID: any) {
    this.onDeleteRow(j, ID);
    this.modalRef.hide();
  }

  onDeleteRow(j, ID) {
    let data = { InquiryProductId: ID, Status: 3 };
    this.spinner.show();
    this.UserService.UpdateInquiryProductStatus(data).subscribe(
      (res) => {
        if (res["result"] == "Success") {
          console.log("1111111111")
          this.spinner.hide();
          let objControls = <FormArray>this.f.ObjInqProduct;
          let fillValue = <FormArray>objControls.controls[j];
          if (fillValue.controls["blankRow"]?.value == "") {
            console.log("aaaaaaaaa")
            objControls.removeAt(j);
          } else {
            console.log("vbbbbbbbbbb")
            this.rowvalue[j] = 3;
            this.cdr.detectChanges();
          }
          setTimeout(() => {
            this.totalsum();
            this.cdr.detectChanges();
          }, 10);
        } else if (res["result"] == "Failed") {
          this.spinner.hide();
          this.checkDelete = res["Data"];
          this.errorMsg = res["Msg"];
          this.showmti.nativeElement.click();
        } else {
          this.toastrService.error(res["Msg"]);
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err && (err.Msg || err.Message)) {
          this.toastrService.error(err.Msg || err.Message);
        }
      }
    );
  }

  onItemSelect(item: any) { }

  view() {
    let encryptid = this.UserService.encryptData(this.id);
    encryptid = encryptid
      .toString()
      .replace("=", "Ar1t")
      .replace("/", "FGH")
      .replace("+", "THD");
    this.router.navigate(["/inquiry/detailinquiry", encryptid]);
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  preventDecimalInput(event: Event, field: string): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    if (event instanceof KeyboardEvent) {
      const charStr = event.key;
      if (!charStr.match(/^[0-9.]$/)) {
        event.preventDefault();
        return;
      }
      if (charStr === '.' && inputValue.includes('.')) {
        event.preventDefault();
        return;
      }
      if (inputValue.includes('.')) {
        const parts = inputValue.split('.');
        if (parts[1].length >= 2 && input.selectionStart > inputValue.indexOf('.')) {
          event.preventDefault();
        }
      }
      input.addEventListener('input', () => {
        const numericValue = parseFloat(input.value);
        if (numericValue < 0.00 || numericValue > 99999.99) {
          let newValue = numericValue;
          if (numericValue < 0.00) {
            newValue = 0.00;
          } else if (numericValue > 99999.99) {
            newValue = Math.floor(numericValue / 10);
          }
          if (field == 'FreightAmountQAR') {
            this.registerForm.get('FreightAmountQAR').setValue(newValue.toFixed(2));
            this.toastrService.error("Freight Amount (QAR) should be between 0.00 to 99999.99");
          }
          else if (field == 'ReportedCurrencyRate') {
            this.registerForm.get('ReportedCurrencyRate').setValue(newValue.toFixed(2));
            this.toastrService.error("Reported Currency Rate should be between 0.00 to 99999.99");
          }
        }
      });
    }
  }

  itemsFormValidate(event: Event, i: number, fieldName: string): void {
    const input = event.target as HTMLInputElement;

    const item = (this.registerForm.get('ObjInqProduct') as FormArray).at(i) as FormGroup;
    const control = item.get(fieldName) as FormControl;

    const inputValue = input.value;
    if (event instanceof KeyboardEvent) {
      const charStr = event.key;
      if (!charStr.match(/^[0-9.]$/)) {
        event.preventDefault();
        return;
      }
      if (charStr === '.' && inputValue.includes('.')) {
        event.preventDefault();
        return;
      }
      if (inputValue.includes('.')) {
        const parts = inputValue.split('.');
        if (parts[1].length >= 2 && input.selectionStart > inputValue.indexOf('.')) {
          event.preventDefault();
        }
      }
      if (fieldName === 'DiscountPer' || fieldName === 'VatRate') {
        input.addEventListener('input', () => {
          const numericValue = parseInt(input.value, 10);
          if (numericValue < 0 || numericValue > 100.00) {
            let newValue = numericValue;
            if (numericValue < 0) {
              newValue = 0;
            } else if (numericValue > 100.00) {
              newValue = Math.floor(numericValue / 10);
            }
            control.setValue(newValue);
            this.toastrService.error("Percentage value should be between 0.00% to 100.00%");
          }
        });
      }
      else if (fieldName === 'Price' || fieldName === 'TotalDiscountValue') {
        input.addEventListener('input', () => {
          const numericValue = parseFloat(input.value);
          if (numericValue < 0.00 || numericValue > 999999.99) {
            let newValue = numericValue;
            if (numericValue < 0.00) {
              newValue = 0.00;
            } else if (numericValue > 999999.99) {
              newValue = Math.floor(numericValue / 10);
            }
            control.setValue(newValue.toFixed(2));
            this.toastrService.error("Value should be between 0.00 to 999999.99");
          }
        });
      }
    }
  }

}
